import React from 'react';
import pt from 'prop-types';
import { SWELL_GLOBAL } from 'components/storefront/editor/utils/easyblocks';

export default class EasyblocksThemeSettings extends React.PureComponent {
  static propTypes = {
    focusedField: pt.string,
  };

  observer = null;

  componentDidMount() {
    this.initObserver();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.focusedField !== this.props.focusedField) {
      this.initObserver();
    }
  }

  componentWillUnmount() {
    this.disconnectObserver();
  }

  initObserver() {
    this.disconnectObserver();

    if (this.props.focusedField !== SWELL_GLOBAL) {
      return;
    }

    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          !(mutation.target instanceof HTMLDetailsElement) ||
          !mutation.target.hasAttribute('open')
        ) {
          return;
        }

        document.querySelectorAll('details').forEach((details) => {
          if (details !== mutation.target) {
            details.removeAttribute('open');
          }
        });
      });
    });

    this.observer.observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ['open'],
    });
  }

  disconnectObserver() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  render() {
    return null;
  }
}
